"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsSpinner = void 0;
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _react = _interopRequireDefault(require("react"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Spinner = _interopRequireDefault(require("react-bootstrap/Spinner"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
 * @Author: Ildomar Carvalho
 * @Email:  ildomar.carvalho@accenture.com
 * @Date:   2023-02-10 11:02:42
 */

/*
 * Description: This component gives you the spinner bootstrap component
 * https://react-bootstrap.github.io/components/spinners/
 *
 * Props: None
 */

const DmsSpinner = () => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animation: "border",
    role: "status",
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("p", null, _reactIntlUniversal.default.get("Loading...").d("Loading...")))));
};
exports.DmsSpinner = DmsSpinner;